import {
    Button,
    Card,
    CardContent,
    CardHeader,
    CircularProgress,
    Grid,
    TextField,
} from "@mui/material";
import { Formik } from "formik";
import { useState } from "react";
import { useLoaderData, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import * as Yup from "yup";

import DefaultApiService from "../../../../../infrastructure/api/default";
import { wrapFormikHandleChange } from "../../../../../infrastructure/utils/formatters";
import BreadcrumbsComponent from "../../../../components/shared/breadcrumbs";
import JalaliDatePicker from "../../../../components/shared/jalali-datetimepicker";
import FileUploader from "../../../../components/shared/uploader/FileUploader";

const validationSchema = Yup.object().shape({});

const ContractorProjectExecutionScheduleModifyPage = () => {
  const data = useLoaderData("root");
  let navigate = useNavigate();
  const { id: roleId } = useParams();

  const [loading, setLoading] = useState(false);

  const onNavigateToListPage = () => {
    navigate("/SLN/Contractor/ProjectExecutionSchedule");
  };

  // Submit Action
  const onSubmit = async (formValue, { setSubmitting }) => {
    setLoading(true);
    const sendData = { ...data.substation, ...formValue };

    try {
      const res = await DefaultApiService.modifyApi(
        "SLN/Contractor/ProjectExecutionSchedule",
        sendData
      );

      if (res.isSuccess) {
        toast.success(res.message);
        onNavigateToListPage();
      } else {
        toast.error(res.message);
      }

      setLoading(false);
    } catch (error) {
      toast.error(error?.response?.data?.message || "خطایی رخ داده است.");

      setLoading(false);
      setSubmitting(false);
    }
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={12}>
        <BreadcrumbsComponent />
      </Grid>

      <Grid item xs={12} md={12}>
        <Card>
          <CardHeader
            title={
              roleId !== "create"
                ? `ویرایش ${data?.projectExecutionSchedule.title}`
                : "ایجاد"
            }
          />

          <CardContent>
            <Formik
              initialValues={data.projectExecutionSchedule}
              validationSchema={validationSchema}
              onSubmit={onSubmit}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
                setFieldValue,
              }) => {
                const onMakeFormikVariable = (name) => ({
                  name: name,
                  fullWidth: true,
                  value: values[name],
                  error: errors[name] && touched[name],
                  helperText: errors[name] && touched[name] && errors[name],
                  variant: "outlined",
                });

                return (
                  <form onSubmit={handleSubmit}>
                    <Grid container spacing={3}>
                      <Grid item xs={12} md={6} lg={3}>
                        <JalaliDatePicker
                          label="تاریخ شروع نصب سازه نگهدارنده ماژول‌های فتوولتائیک"
                          onChange={(value) => {
                            setFieldValue(
                              "mountStructureInstallationStartDateTime",
                              value
                            );
                          }}
                          {...onMakeFormikVariable(
                            "mountStructureInstallationStartDateTime"
                          )}
                        />
                      </Grid>

                      <Grid item xs={12} md={6} lg={3}>
                        <JalaliDatePicker
                          label="تاریخ پایان نصب سازه نگهدارنده ماژول‌های فتوولتائیک"
                          onChange={(value) => {
                            setFieldValue(
                              "mountStructureInstallationEndDateTime",
                              value
                            );
                          }}
                          {...onMakeFormikVariable(
                            "mountStructureInstallationEndDateTime"
                          )}
                        />
                      </Grid>
                      <Grid item xs={12} md={6} lg={3}>
                        <JalaliDatePicker
                          label="تاریخ شروع نصب تجهیزات الکتریکی DC نیروگاه"
                          onChange={(value) => {
                            setFieldValue(
                              "dcElectricalInstallationStartDateTime",
                              value
                            );
                          }}
                          {...onMakeFormikVariable(
                            "dcElectricalInstallationStartDateTime"
                          )}
                        />
                      </Grid>

                      <Grid item xs={12} md={6} lg={3}>
                        <JalaliDatePicker
                          label="تاریخ پایان نصب تجهیزات الکتریکی DC نیروگاه"
                          onChange={(value) => {
                            setFieldValue(
                              "dcElectricalInstallationEndDateTime",
                              value
                            );
                          }}
                          {...onMakeFormikVariable(
                            "dcElectricalInstallationEndDateTime"
                          )}
                        />
                      </Grid>
                      <Grid item xs={12} md={6} lg={3}>
                        <JalaliDatePicker
                          label="تاریخ شروع نصب تجهیزات الکتریکی AC نیروگاه"
                          onChange={(value) => {
                            setFieldValue(
                              "acElectricalInstallationStartDateTime",
                              value
                            );
                          }}
                          {...onMakeFormikVariable(
                            "acElectricalInstallationStartDateTime"
                          )}
                        />
                      </Grid>

                      <Grid item xs={12} md={6} lg={3}>
                        <JalaliDatePicker
                          label="تاریخ پایان نصب تجهیزات الکتریکی AC نیروگاه"
                          onChange={(value) => {
                            setFieldValue(
                              "acElectricalInstallationEndDateTime",
                              value
                            );
                          }}
                          {...onMakeFormikVariable(
                            "acElectricalInstallationEndDateTime"
                          )}
                        />
                      </Grid>
                      <Grid item xs={12} md={6} lg={3}>
                        <JalaliDatePicker
                          label="تاریخ شروع آزمایش و راه‌اندازی اولیه نیروگاه"
                          onChange={(value) => {
                            setFieldValue(
                              "initialCommissioningStartDateTime",
                              value
                            );
                          }}
                          {...onMakeFormikVariable(
                            "initialCommissioningStartDateTime"
                          )}
                        />
                      </Grid>

                      <Grid item xs={12} md={6} lg={3}>
                        <JalaliDatePicker
                          label="تاریخ پایان آزمایش و راه‌اندازی اولیه نیروگاه"
                          onChange={(value) => {
                            setFieldValue(
                              "initialCommissioningEndDateTime",
                              value
                            );
                          }}
                          {...onMakeFormikVariable(
                            "initialCommissioningEndDateTime"
                          )}
                        />
                      </Grid>

                      <Grid item xs={12} md={12} lg={6}>
                        <TextField
                          label="توضیحات"
                          multiline
                          minRows={2}
                          onChange={wrapFormikHandleChange(handleChange)}
                          {...onMakeFormikVariable("description")}
                        />
                      </Grid>
                      <Grid item xs={12} md={12}>
                        <FileUploader
                          moduleName={"SLN/Contractor"}
                          maxFiles={1}
                          label="فایل زمان بندی "
                          onChange={(list) => {
                            console.log(list);

                            if (list.length > 0) {
                              setFieldValue("contractFileUrl", list[0]);
                            } else {
                              setFieldValue("contractFileUrl", "");
                            }
                          }}
                          baseurl={data.baseUrl}
                          placeholder={"فایل مورد نظر را انتخاب کنید"}
                          {...onMakeFormikVariable("contractFileUrl")}
                        />
                      </Grid>

                      <Grid
                        item
                        xs={12}
                        md={12}
                        container
                        justifyContent={"flex-end"}
                      >
                        <Button
                          disabled={isSubmitting}
                          variant="outlined"
                          size="large"
                          color="gray"
                          sx={{ mx: 1 }}
                          onClick={onNavigateToListPage}
                        >
                          انصراف
                        </Button>

                        <Button
                          disabled={isSubmitting}
                          variant="contained"
                          type="submit"
                          size="large"
                        >
                          {loading && (
                            <CircularProgress size={16} color="inherit" />
                          )}
                          {roleId !== "create" ? "ویرایش" : "ایجاد"}
                        </Button>
                      </Grid>
                    </Grid>
                  </form>
                );
              }}
            </Formik>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default ContractorProjectExecutionScheduleModifyPage;
